import { attributes, type HtmlValue, html, joinClasses } from 'BomdisoftComponents/html/index';

export type ImageWithFallbackOptions = {
  alt: string;
  className?: string;
  fallback?: string;
  fallbackIcon?: HtmlValue;
  fill?: boolean;
  height?: number;
  priority?: boolean;
  src?: string | null;
  width?: number;
};

export const DEFAULT_IMAGE_FALLBACK = '/images/fallback.webp';

export const toInitials = (alt: string) => alt.split(' ').reduce((acc, cur, ind) => (ind < 2 ? acc + cur.charAt(0) : acc), '');

export const hasFallbackIcon = (fallbackIcon: unknown) => fallbackIcon !== undefined && fallbackIcon !== null && fallbackIcon !== false;

const renderAvatar = (alt: string, className?: string) => html`<div${attributes({ class: joinClasses('bomdisoft-image-with-fallback-avatar', className), 'data-testid': 'iwf-avatar' })}>${toInitials(alt)}</div>`;

export const renderImageWithFallback = ({ alt, className, fallback = DEFAULT_IMAGE_FALLBACK, fallbackIcon, fill = false, height, priority = false, src, width }: ImageWithFallbackOptions) => {
  if (!src || (!fill && (!height || !width))) return renderAvatar(alt, className);
  const withIcon = hasFallbackIcon(fallbackIcon);
  const image = html`<img${attributes({
    alt,
    class: joinClasses('bomdisoft-image-with-fallback-image', className),
    'data-bomdisoft-fallback': withIcon ? undefined : fallback,
    'data-bomdisoft-fallback-icon': withIcon,
    'data-fill': fill,
    'data-testid': 'iwf-image',
    decoding: 'async',
    fetchpriority: priority ? 'high' : undefined,
    height: fill ? undefined : height,
    loading: priority ? undefined : 'lazy',
    src,
    width: fill ? undefined : width,
  })}>`;
  return withIcon ? html`${image}<span class="bomdisoft-image-with-fallback-icon" hidden="">${fallbackIcon}</span>` : image;
};
